import { createSelector } from 'reselect';

import { IBindingCard } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';

import { TState } from '~/src/store';

interface ICardsGroup {
    blockTitle: string,
    cardsList: IBindingCard[],
}

interface ICardsInfo {
    isCards: boolean,
    isAutoPayCard: boolean,
    cardGroups: ICardsGroup[],
}

interface IPaySystem {
    [key: string]: string[],
}

const paySystemCodes: IPaySystem = {
    'MIR': ['2'],
    'AmericanExpress': ['34', '37'],
    'JCB': ['31', '35'],
    'DinersClub': ['30', '36', '38'],
    'VISA': ['4'],
    'MasterCard': ['51', '52', '53', '54', '55'],
    'Maestro': ['50', '56', '57', '58', '63', '67'],
    'UnionPay': ['62'],
    'Discover': ['60'],
    'UEC': ['7'],
};

export const selectCardsWithPaySystem = createSelector(
    (state: TState) => state.auth.clientPayment?.bindingCards,
    cards => {
        return cards?.reduce((acc: ICardsInfo, card: IBindingCard) => {
            const { maskedNumber, autoPayStatus } = card;

            const _number = maskedNumber.split(' ');
            const lastNumberGroup = _number[_number.length - 1];
            const oneSymbolCode = maskedNumber.charAt(0);
            const twoSymbolsCode = maskedNumber.substring(0, 2);

            for (const key in paySystemCodes) {
                if (paySystemCodes[key].includes(oneSymbolCode) || paySystemCodes[key].includes(twoSymbolsCode)) {
                    card.paySystem = key;
                    card.numberWithPaySystem = `${key} •• ${lastNumberGroup}`;
                }
            }

            if (autoPayStatus) {
                acc.isCards = true;
                acc.isAutoPayCard = true;
                acc.cardGroups[0].cardsList.push(card);
            } else {
                acc.isCards = true;
                acc.cardGroups[1].cardsList.push(card);
            }

            return acc;
        }, {
            isCards: false,
            isAutoPayCard: false,
            cardGroups: [
                {
                    blockTitle: 'Для автоплатежа',
                    cardsList: [],
                },
                {
                    blockTitle: 'Дополнительные',
                    cardsList: [],
                },
            ],
        });
    },
);
